import React from "react";
import { UnitTypesKey } from "../../helpers/constants/siteCoreKeys";
import { useNavigationSiteCore } from "../../hooks/useNavigationSiteCore";
import { useSiteCore } from "../../hooks/useSiteCore";
import { FormController } from "../formController/FormController";
import { MuiSelect } from "../select/MuiSelect";
import { MuiTextField } from "../textField/MuiTextfield";

interface MeasurementInputProps {
  selectedUnit: string;
  measurementOtherMinuteName: string;
  measurementOther: string;
  control: any; // Define the type for your control (e.g., react-hook-form)
  pageId: string;
  parentKey: string;
  minutesLabelKey: string;
  minuteListKey: string;
  quantityLabelKey: string;
  daysLabelKey: string;
  isMandatory?: boolean;
  disabled?: boolean;
}

const MeasurementInput: React.FC<MeasurementInputProps> = ({
  selectedUnit,
  measurementOtherMinuteName,
  measurementOther,
  control,
  pageId,
  parentKey,
  minutesLabelKey,
  quantityLabelKey,
  daysLabelKey,
  minuteListKey,
  isMandatory = true,
  disabled = false,
}) => {
  const { commonLabels, fetchLabel, fetchDropdownValues } = useSiteCore();
  const { commonARIALabel } = useNavigationSiteCore();

  return (
    <>
      {selectedUnit === UnitTypesKey.Minutes && (
        <FormController control={control} name={measurementOtherMinuteName}>
          <MuiSelect
            disabled={disabled}
            label={fetchLabel(parentKey, minutesLabelKey)}
            visibleDefaultSelectOption
            options={fetchDropdownValues(parentKey, minuteListKey)}
            isMandatory={isMandatory}
            id={`${pageId}-${measurementOtherMinuteName}`}
            placeholder={commonLabels.selectPlaceHolder}
            requiredARIALabel={commonARIALabel.required}
          />
        </FormController>
      )}

      {(selectedUnit === UnitTypesKey.Count ||
        selectedUnit === UnitTypesKey.Days) && (
        <FormController control={control} name={measurementOther}>
          <MuiTextField
            disabled={disabled}
            label={fetchLabel(
              parentKey,
              selectedUnit === UnitTypesKey.Count
                ? quantityLabelKey
                : daysLabelKey,
            )}
            id={`${pageId}-${measurementOther}`}
            type="number"
            placeholder={commonLabels.inputPlaceHolder}
            isMandatory={isMandatory}
            inputNumberWithoutDecimal
            requiredARIALabel={commonARIALabel.required}
          />
        </FormController>
      )}
    </>
  );
};

export default MeasurementInput;
